import React, { useEffect, useState } from "react";
import {
  Checkbox,
  Menu,
  MenuItem,
  IconButton,
  Typography,
  useMediaQuery,
  makeStyles,
} from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { useTheme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  trigger: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  label: {
    flex: 1,
    fontWeight: 500,
  },
}));

export function CustomMenu(props) {
  const { options, selectedOption, onHandleSelectOption,children, ...rest } = props;
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenMenu = (event) => {
    if (document.activeElement) document.activeElement.blur(); // ✅ quita foco
    setAnchorEl(event.currentTarget);
  };
  
  const handleCloseMenu = () => {
    if (document.activeElement) document.activeElement.blur(); // ✅ quita foco
    setAnchorEl(null);
  };

  const handleSelectOption = (option) => {
    onHandleSelectOption(option);
    handleCloseMenu();
  };

  useEffect(() => {
    return () => {
      onHandleSelectOption("");
    };
  }, []);
  return (
    <>
      {/* Trigger */}
      <div className={classes.trigger} onClick={handleOpenMenu}>
        {children || <DefaultTrigger/>}
      </div>

      {/* Menu opciones */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        {options.map((option) => (
          <MenuItem
            key={option.value}
            selected={option.value === selectedOption}
            onClick={() => handleSelectOption(option.value)}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

function DefaultTrigger() {
  return (
    <div style={{ display: "flex", alignItems: "center", color: "inherit" }}>
      <Typography>Menu</Typography>
      <IconButton size="small" color="inherit">
        <ArrowDropDownIcon />
      </IconButton>
    </div>
  );
}
